/**
 * Test if Sentry endpoint is accessible (direct adblocker detection)
 */
export const isSentryBlocked = async (): Promise<boolean> => {
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (!sentryDsn) {
    return true; // No DSN means Sentry is "blocked"
  }

  try {
    // Extract the Sentry endpoint from the DSN
    const dsnUrl = new URL(sentryDsn);
    const projectId = dsnUrl.pathname.split('/')[1];
    const sentryKey = dsnUrl.username;
    
    // Construct the Sentry envelope endpoint
    const envelopeUrl = `https://${dsnUrl.hostname}/api/${projectId}/envelope/?sentry_version=7&sentry_key=${sentryKey}&sentry_client=sentry.javascript.react%2F10.10.0`;
    
    // Test if we can reach the Sentry endpoint
    await fetch(envelopeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-sentry-envelope',
      },
      body: '{"type":"test"}\n{"test":true}',
      mode: 'cors',
    });
    
    // If we get any response (even an error), the endpoint is reachable
    return false; // Not blocked
  } catch (error) {
    // If fetch fails, Sentry is likely blocked
    return true; // Blocked
  }
};
